if (!customElements.get('show-more-description')) {
  customElements.define(
    'show-more-description',
    class ShowMoreDescription extends HTMLElement {
      connectedCallback() {
        this.description = this.querySelector('.product__description');
        this.button = this.querySelector('.product__description-toggle');
        if (!this.description || !this.button) return;

        this.moreLabel = this.button.querySelector('.product__description-toggle--more');
        this.lessLabel = this.button.querySelector('.product__description-toggle--less');
        this.expanded = false;

        this.button.addEventListener('click', this.toggle.bind(this));
        this.onResize = this.checkOverflow.bind(this);
        window.addEventListener('resize', this.onResize);

        // Wait for layout (fonts/images) before measuring.
        requestAnimationFrame(() => this.checkOverflow());
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.onResize);
      }

      checkOverflow() {
        if (this.expanded) return;
        const overflowing = this.description.scrollHeight > this.description.clientHeight + 1;
        this.button.classList.toggle('is-visible', overflowing);
      }

      toggle() {
        this.expanded = !this.expanded;
        this.description.classList.toggle('product__description--truncated', !this.expanded);
        this.button.setAttribute('aria-expanded', String(this.expanded));
        if (this.moreLabel) this.moreLabel.hidden = this.expanded;
        if (this.lessLabel) this.lessLabel.hidden = !this.expanded;

        // When collapsing, re-evaluate whether the button is still needed.
        if (!this.expanded) requestAnimationFrame(() => this.checkOverflow());
      }
    }
  );
}
